export enum TIERS {
  TIER_1 = 'Tier1',
  TIER_2 = 'Tier2',
  TIER_3 = 'Tier3',
}

export type TIER_VALUES = typeof TIERS[keyof typeof TIERS];
